/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCatalogField } from '../../models/api-response-catalog-field';
import { CatalogField } from '../../models/catalog-field';

export interface AddCatalogField$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: CatalogField
}

export function addCatalogField(http: HttpClient, rootUrl: string, params: AddCatalogField$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCatalogField>> {
  const rb = new RequestBuilder(rootUrl, addCatalogField.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCatalogField>;
    })
  );
}

addCatalogField.PATH = '/v1/api/ui/company/catalog-config/field';
